import useDeckLoader from 'hooks/useDeckLoader';
import { useParams } from 'react-router-dom';
import RevealDeck from 'components/RevealDeck';
import LoadingOverlay from 'components/LoadingOverlay/LoadingOverlay';

export default function SlideDeckPage() {
  const { id } = useParams();
  const { deck, loading, error } = useDeckLoader({ idFromRoute: id });

  if (error) return <div className="p-10 text-red-600 text-xl">Error: {error}</div>;

  return (
    <>
      <LoadingOverlay open={loading} title="Loading deck…" />
      {deck && <RevealDeck deck={deck} />}
      {import.meta.env.VITE_DEPLOY_ENV && (
        <span style={{
          position: 'fixed', bottom: '8px', right: '12px',
          fontSize: '11px', color: '#9ca3af', zIndex: 9999
        }}>
          | {import.meta.env.VITE_DEPLOY_ENV.toUpperCase()}
        </span>
      )}
    </>
  );
}
